<template>
  <div>
    <div v-if="trail">
      <div class="row justify-content-between">
        <div class="col-12 col-md-3 d-flex align-items-center">
          <button @click="addReview" class="btn btn-secondary btn-block my-3">
            Review this trail
          </button>
        </div>
        <div class="col-12 col-md-4" v-if="trail.reviews.length > 1">
          <p class="text-muted float-left mr-3 mb-2 pl-3"> Sort:</p>
          <p class="p-2 bg-dark w-100 rounded">
            <select class="custom-select float-right w-100" v-model="selectedOrder">
              <option v-for="order in orderings" :key="order" :value="order" >ordered by {{ order }}</option>
            </select>
          </p>
        </div>
      </div>

      <div class="trail-reviews">
        <div id="reviews_container">
          <Review v-for="review in orderedReviews"
                  :key="review.id"
                  :review="review" />
        </div>
      </div>
    </div>
    <p v-if="trail === null" class="d-flex align-items-center my-3 display-5">
      <span class="spinner-border spinner-border-md mr-2"></span>
      Loading reviews...
    </p>
    <div v-if="error">{{ error }}</div>
    <div v-if="trail && trail.reviews.length === 0 && !showModal">
      <div class="mt-3">
        <h4><strong>No reviews yet!</strong></h4>
        <p>Be the first to review this trail.</p>
      </div>
    </div>
    <ReviewDialog ref="reviewDialog" />
    <LoadingDialog :show-loading-dialog="newReviewLoading"/>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Review from './Review.vue';
import ReviewDialog from './ReviewDialog.vue';
import LoadingDialog from "../../utils/shared_components/LoadingDialog.vue";

export default {
  components: {
    LoadingDialog,
    Review,
    ReviewDialog,
  },
  computed: {
    ...mapState(['trail', 'user', 'error', 'orderings', 'showModal', 'newReviewLoading']),
    ...mapGetters(['orderedReviews']),
    selectedOrder: {
      get() {
        return this.$store.state.selectedOrder;
      },
      set(value) {
        this.$store.dispatch('setSelectedOrder', value);
      },
    },
  },
  methods: {
    addReview() {
      this.$store.dispatch('addReview', null);
    },
  },
  mounted() {
    this.$store.dispatch('fetchTrail');
  },
};
</script>
